import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const BillingAlertsUsageManagement = lazy(() =>
  import("@scenes/BillingAlerts/BillingAlertsUsageManagement/BillingAlertsUsageManagement").then((module) => ({
    default: module.BillingAlertsUsageManagement,
  }))
);

export const billingAlertsUsageManagementNRO: NavigationRoutingObject = {
  Component: BillingAlertsUsageManagement,
  noKnockoutFallback: true,
  componentFeatureFlippers: [],
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("billing-alerts-usage-management-nro-heading", "Usage Management"),
  pageNameForTracking: () => "Billing Alerts - Usage Management",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    // Keep in sync with billingAlertsNRO and the Billing Alerts link in SettingsMenuItems
    return (
      featureOn("enable_billing_governance_controls") && hasPermission("appGroup", { permission: "viewBilling" })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
